/**
 * 【KYMW5002】画像リスト取得VO
 *
 * @export GetImageListModel
 * @class GetImageListModel
 */
export class GetImageListModel {
  /** Ｐコード */
  public pcode = String('');

  /** 受注コード */
  public orderCode = String('');
}
